import awsAuthErrorTypes from '../../consts/aws/awsAuthErrorTypes';
import damApiErrorMessages from '../../consts/dam/damApiErrorMessages';
import damTokenErrorTypes from '../../consts/dam/damTokenErrorTypes';
import AuthTokenError from '../../errors/authTokenError';
import InactiveSessionError from '../../errors/inactiveSessionError';
import RequestCachedError from '../../errors/requestCachedError';
import {setDeviceAuthToken} from '../../state/slice/iotDevices';
import {dispatch} from '../../state/store';
import awsAuthService from '../aws/awsAuthService';
import cacheService from '../cacheService';
import httpStatusTypesService from '../httpStatusTypesService';

const MAX_NUMBER_OF_RETRY = 3;

export const createClientError = () => {
    let client;

    const setClient = (c) => {
        client = c;
    };

    const handleRequestError = async ({e, url, isUamToken, isThrowError, isImportantRequest, args}) => {
        if (isUamToken) {
            await handleTokenError(e, args);
        } else {
            await handleAwsError(e);
        }

        if (isImportantRequest) {
            await handleImportantRequest(e, url, args);
        }

        if (isThrowError) throw e;
    };

    const handleTokenError = async (error, args) => {
        const {response} = error ?? {};
        const {message} = response?.data?.error ?? {};

        const isNotAuthorized = httpStatusTypesService.getIsNotAuthorized(response?.status);
        const isAuthTokenError = error instanceof AuthTokenError;

        if (
            message === damApiErrorMessages.SESSION_NOT_ACTIVE ||
            message === damApiErrorMessages.ENVIRONMENT_MISMATCH
        ) {
            await awsAuthService.handleAuthenticationError(new InactiveSessionError());
            return;
        }

        if (isNotAuthorized || isAuthTokenError) {
            await retryRequestIfAllowed(args);
        }
    };

    const handleAwsError = async (error) => {
        const {code, response} = error ?? {};
        const {error: responseError} = response?.data ?? {};

        const shouldSignOut =
            code === awsAuthErrorTypes.NOT_AUTHORIZED_EXCEPTION ||
            responseError === damTokenErrorTypes.AP_TOKEN_IS_REVOKED;

        if (!shouldSignOut) return;

        const authError = code === awsAuthErrorTypes.NOT_AUTHORIZED_EXCEPTION ? error : new InactiveSessionError();

        await awsAuthService.handleAuthenticationError(authError);
    };

    const retryRequestIfAllowed = async (args) => {
        const retryCount = args.retryCount ?? 1;

        if (retryCount < MAX_NUMBER_OF_RETRY) {
            dispatch(setDeviceAuthToken(args.serialNumber, null));
            await client.callRequest({...args, retryCount: retryCount + 1});
        }
    };

    const handleImportantRequest = async (error, url, args) => {
        const isCachedError = error instanceof RequestCachedError;

        if (!isCachedError) {
            await cacheService.cacheImportantRequest(url, args);
        }
    };

    return {handleRequestError, setClient};
};
